/**
 * Currently only used by the bulkVendors.js file. This is a service that is used to make HTTP calls to the server.
 *
 * TODO: https://graystep.atlassian.net/browse/GR-1458
 */
/* @ngInject */ export function vendorsServiceProvider() {
  this.httpServiceBase = '/books/vendors/';
  this.httpServices = {
    /**
     * Sends a list of vendor ID's to the server to deactivate them.
     *
     * @param {number[]} ids
     * @returns true (Success)
     */
    bulkDeactivateVendors: function (ids) {
      return this.post('bulkDeactivateVendors', { ids });
    }
  };

  this.$get = ['HTTPService', function (HTTPService) {
    return Object.assign(
      HTTPService.make(this.httpServiceBase),
      this.httpServices
    );
  }];
}
